/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';

import { jobsDepartments } from '../../../utils/dataFunctions';
import TeamCard from './components/TeamCard';

import styles from './styles.module.scss';

export const TeamCards = ({ comeetPositions }) => {
    const [teams, setTeams] = useState({});

    useEffect(() => {
        setTeams(jobsDepartments(comeetPositions));
    }, [comeetPositions]);
    return (
        <>
            <div className="page-container">
                <div className={`${styles.teamCardsContainer}`}>
                    {Object.keys(teams).map((team) => (
                        <TeamCard key={team} id={team} count={teams[team]} />
                    ))}
                </div>
            </div>
        </>
    );
};
